import { z } from "zod";

/**
 * Contrat de la coquille de la console : les drapeaux du Lab affiches dans le bandeau.
 *
 * Pourquoi une route de l'app et pas une route du template : la couche Lab lit bien les
 * drapeaux (`guard.state().flags`), mais elle ne les publie nulle part qu'un navigateur
 * puisse atteindre. Le seul endroit ou ils sortent est `/metrics`, protege par
 * `METRICS_TOKEN` et volontairement absent du proxy public (e2e du template :
 * « le point de controle interne n est pas expose au public »). La console les sert donc
 * elle-meme, derriere sa propre garde : session Better Auth **et** liste blanche, comme
 * les trois routes du portefeuille.
 *
 * Trois drapeaux seulement, ceux que la spec demande (section 3, « la coquille »). Les
 * autres (`signupOpen`, `maintenance`) ne regardent pas la personne qui lit la page.
 */
export const drapeauxSchema = z.object({
  stopAll: z.boolean(),
  pauseSpend: z.boolean(),
  pausePublish: z.boolean(),
  /** false quand lab-tools n'a pas repondu : les drapeaux affiches sont alors inconnus. */
  joignable: z.boolean(),
  /** true quand l'etat connu a plus de 30 s (le guard le rafraichit en arriere-plan). */
  perime: z.boolean(),
});
export type Drapeaux = z.infer<typeof drapeauxSchema>;
